import { Download } from "lucide-react";

/**
 * ExportCsvButton — authenticated CSV download via fetch + Bearer (since <a href>
 * can't carry an Authorization header). Triggers a normal browser save.
 */
export default function ExportCsvButton({ endpoint, filename, label = "Export CSV", testId = "export-csv-btn" }) {
  const handleClick = async () => {
    const token = localStorage.getItem("jrc_token");
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/exports/${endpoint}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#5B2C82] bg-white px-3 py-1.5 text-xs font-semibold text-[#5B2C82] transition-colors hover:bg-[#5B2C82] hover:text-white"
    >
      <Download className="h-3.5 w-3.5" /> {label}
    </button>
  );
}
